import { styled } from 'styled-components';

export const AlertAcknowledgeFooterWrapper = styled.footer`
  display: flex;
  flex-direction: row;
  margin: ${({ theme }) => theme.spacing(2)}px;
`;
